export default "__VITE_ASSET__DHEuItIh__"